import {Injectable} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';

@Injectable()
export class ScrollTopService {

    constructor(
        private router: Router
    ) {
    }

    setScrollTop() {
        this.router.events.subscribe((event: NavigationEnd) => {
            window.scroll(0, 0);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/scroll-top.service.ts